export default __webpack_public_path__ + "static/media/unauthorized.c02d7622.png";